import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import InboxIcon from "@material-ui/icons/MoveToInbox";
import MailIcon from "@material-ui/icons/Mail";
import Container from "@material-ui/core/Container";
import TextField from "@material-ui/core/TextField";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";

import PhoneIcon from "@material-ui/icons/Phone";
import FavoriteIcon from "@material-ui/icons/Favorite";
import StarIcon from "@material-ui/icons/Star";
import PersonPinIcon from "@material-ui/icons/PersonPin";

import Sets from "../shared/Sets";
import CollectionNames from "../shared/CollectionNames";
import CollectionLevels from "../shared/CollectionLevels";

const useStyles = makeStyles({
  list: {
    //  width: 250,
  },
  myul: {
    //  maxHeight: 700,
    // overflowY:'scroll',
    //overflow-y: scroll,
  },
  limit: {
    // width:100, comment star
  },
  myDrawer: {
    // width:250,comment star
    // width:150
  },
  fullList: {
    width: "auto",
    //    maxWidth:200
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default function SwipeableTemporaryDrawer(props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
    limit: 100,
    tab: 0,
    table: "word_set",
    levels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  });
  // console.log(props);
  // alert("sws");
  //let swipe = props;

  //let sets = props.sets.unshift({name:"All"});

  var selected_set = "";
  var selected_level = "";

  function handleSelectChange(name) {
    //alert(name);
    selected_set = name;
  }

  function handleCollectionLevelChange(name) {
    selected_level = name;
  }

  function handleSelectChangeButtonClick() {
    console.log(selected_set);
    props.handleChangeSet(selected_set);
  }
  function handleLevelChangeButtonClick() {
    //alert(state.table);
    props.handleChangeLevel(selected_level, state.table);
  }
  function handleExportEXCEL() {
    props.handleExportEXCEL();
  }
  function handleCollectionChange(name) {
    setState({
      ...state,
      table: name,
    });
  }

  function handleSelectChangeButtonClick() {
    props.handleChangeSet(selected_set);
  }

  function buttonPressed(name) {
    props.handleSetFilter(name, parseInt(state.limit), state.table, "set");
  }

  function FilterByLevel(name) {
    props.handleSetFilter(name, parseInt(state.limit), state.table, "level");
  }

  function handleChange(e) {
    setState({
      ...state,
      [e.target.id]: e.target.value,
    });
  }

  function handleTabChange(event, newValue) {
    // alert(newValue);
    setState({
      ...state,
      tab: newValue,
    });
    //setValue(newValue);
  }

  const toggleDrawer = (side, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [side]: open });
  };

  const sideList = (side, sets) => (
    <div
      className={classes.list}
      role="presentation"
      //   onClick={toggleDrawer(side, false)}
      //  onKeyDown={toggleDrawer(side, false)}
    >
      <List className={classes.myul}>
        <ListItem button key={"All"} onClick={() => buttonPressed("All")}>
          <ListItemText primary={"All"} />
        </ListItem>
        <ListItem button key={"Empty"} onClick={() => buttonPressed("")}>
          <ListItemText primary={"Empty"} />
        </ListItem>
        <ListItem
          button
          key={"Bookmarked"}
          onClick={() => buttonPressed("Bookmarked")}
        >
          <ListItemText primary={"Bookmarked"} />
        </ListItem>
        {typeof sets != "undefined" &&
          sets.map((se) => (
            <ListItem
              button
              key={se.name}
              onClick={() => buttonPressed(se.name)}
            >
              <ListItemText primary={se.name} />
            </ListItem>
          ))}
      </List>
      <Divider />
      {/* <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem button key={text}>
            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
            <ListItemText primary={text} />
          </ListItem>
        ))}

      </List> */}
    </div>
  );

  //   const fullList = side => (
  //     <div
  //       className={classes.fullList}
  //       role="presentation"
  //       onClick={toggleDrawer(side, false)}
  //       onKeyDown={toggleDrawer(side, false)}
  //     >
  //       <List>
  //         {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
  //           <ListItem button key={text}>
  //             <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
  //             <ListItemText primary={text} />
  //           </ListItem>
  //         ))}
  //       </List>
  //       <Divider />
  //       <List>
  //         {['All mail', 'Trash', 'Spam'].map((text, index) => (
  //           <ListItem button key={text}>
  //             <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
  //             <ListItemText primary={text} />
  //           </ListItem>
  //         ))}
  //       </List>
  //     </div>
  //   );

  return (
    <div>
      {/* <Button onClick={toggleDrawer('left', true)}>Open Left</Button> */}

      <div hidden id="main_button_helper" onClick={toggleDrawer("right", true)}>
        Open Right
      </div>

      {/* <Button onClick={toggleDrawer('top', true)}>Open Top</Button>
      <Button onClick={toggleDrawer('bottom', true)}>Open Bottom</Button> */}
      {/* <SwipeableDrawer
        open={state.left}
        onClose={toggleDrawer('left', false)}
        onOpen={toggleDrawer('left', true)}
      >
        {sideList('left')}
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="top"
        open={state.top}
        onClose={toggleDrawer('top', false)}
        onOpen={toggleDrawer('top', true)}
      >
        {fullList('top')}
      </SwipeableDrawer>
      <SwipeableDrawer
        anchor="bottom"
        open={state.bottom}
        onClose={toggleDrawer('bottom', false)}
        onOpen={toggleDrawer('bottom', true)}
      >
        {fullList('bottom')}
      </SwipeableDrawer> */}
      <SwipeableDrawer
        anchor="right"
        open={state.right}
        onClose={toggleDrawer("right", false)}
        onOpen={toggleDrawer("right", true)}
      >
        <div className={classes.myDrawer}>
          <br></br>

          <Tabs
            id="tab"
            value={state.tab}
            onChange={handleTabChange}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="secondary"
            aria-label="icon label tabs example"
          >
            <Tab icon={<PhoneIcon />} />
            <Tab icon={<FavoriteIcon />} />
            <Tab icon={<StarIcon />} />
          </Tabs>

          {state.tab === 0 && (
            <TabContainer>{sideList("right", props.sets)}</TabContainer>
          )}

          {state.tab === 1 && (
            <TabContainer>
              <Container fixed>
                <br></br>
                <TextField
                  id="limit"
                  label="limit"
                  type="number"
                  className={classes.limit}
                  value={state.limit}
                  onChange={handleChange}
                  margin="dense"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
                <br></br>
                <br></br>
                <CollectionNames
                  handleCollectionChange={handleCollectionChange}
                ></CollectionNames>
                <br></br>
                <br></br>
                <Sets
                  className={classes.limit}
                  handleSelectChange={handleSelectChange}
                  sets={props.sets}
                ></Sets>
                <br></br>
                <br></br>
                <Button
                  onClick={() => handleSelectChangeButtonClick()}
                  variant="contained"
                  color="secondary"
                >
                  Update
                </Button>
                <Button
                  onClick={() => handleExportEXCEL()}
                  variant="contained"
                  color="secondary"
                >
                  Export
                </Button>
              </Container>
            </TabContainer>
          )}

          {state.tab === 2 && (
            <TabContainer>
              <List className={classes.myul}>
                {/* <ListItem
                  button
                  key={"All"}
                  onClick={() => buttonPressed("All")}
                >
                  <ListItemText primary={"All"} />
                </ListItem>
                <ListItem
                  button
                  key={"Bookmarked"}
                  onClick={() => buttonPressed("Bookmarked")}
                >
                  <ListItemText primary={"Bookmarked"} />
                </ListItem> */}
                {typeof state.levels != "undefined" &&
                  state.levels.map((se) => (
                    <ListItem button key={se} onClick={() => FilterByLevel(se)}>
                      <ListItemText primary={se} />
                    </ListItem>
                  ))}
              </List>

              <CollectionLevels
                handleCollectionLevelChange={handleCollectionLevelChange}
              ></CollectionLevels>
              <br></br>
              <br></br>
              <Button
                onClick={() => handleLevelChangeButtonClick()}
                variant="contained"
                color="secondary"
              >
                Update
              </Button>
            </TabContainer>
          )}
        </div>
      </SwipeableDrawer>
    </div>
  );
}
